import Stepper from "@/components/common/Stepper";
import { AdminCreateUserWizardNav } from "@/features/admin/components/AdminCreateUserWizardNav";
import { AdminUserOrgRolesSection } from "@/features/admin/components/AdminManageUserOrgsDialog";
import { getCreateUserWizardSteps, validateCreateUserWizardSearch } from "@/features/admin/utils/createUserWizard";
import { useProfileByIdQuerySafe } from "@/features/profile/api/selectProfile";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/users/create-user/organisations")({
    validateSearch: validateCreateUserWizardSearch,
    beforeLoad: ({ search }) => {
        if (!search.userId) {
            throw redirect({ to: "/users/create-user/details" });
        }
    },
    component: CreateUserOrganisationsStep,
});

function CreateUserOrganisationsStep() {
    const search = Route.useSearch();
    const userId = search.userId!;
    const { data: profile } = useProfileByIdQuerySafe(userId);
    const displayName =
        [profile?.first_name, profile?.last_name].filter(Boolean).join(" ") || profile?.email || "this user";

    return (
        <div className="space-y-6" data-testid="create-user-organisations-step">
            <Stepper steps={getCreateUserWizardSteps("organisations", search)} />
            <div className="space-y-2">
                <h2 className="font-medium text-lg">Organisations & roles</h2>
                <p className="text-muted-foreground text-sm">
                    Assign one or more organisations and roles for {displayName}. If their organisation is not listed,
                    create it with &ldquo;New organisation&rdquo;.
                </p>
            </div>
            <AdminUserOrgRolesSection userId={userId} userName={displayName} allowCreateOrganisation />
            <AdminCreateUserWizardNav
                search={search}
                backTo="/users/create-user/details"
                nextTo="/users/create-user/access"
            />
        </div>
    );
}
